window.addEventListener('load', function() {
  // Scroll shadow on header wrapper
  var wrapper = document.querySelector('.header-wrapper');
  if (wrapper) {
    window.addEventListener('scroll', function() {
      wrapper.classList.toggle('header-wrapper--scrolled', window.scrollY > 8);
    }, { passive: true });
  }
});